const IwinPrefix = ['CC', 'AA', 'FF', 'PP', 'EE', 'BB', 'HH', 'RR'];
const IwinPrefixDigit = ['R', 'S', 'T', 'W', 'Y'];
const IwinFirst3 = IwinPrefix.map((prefix) => IwinPrefixDigit.map((digit) => `${prefix}${digit}`)).flat();

const coefficients = [2, 7, 6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

/**
 * Validate the last digit of the receptionNo
 * 1. Define the first 3 numbers to use in calculation according to the given receptionNo,
 * 2. Multiply every first 13 numbers with a pre-defined coefficients.
 * 3. Sum each product to get a subtotal that will be divided per 11
 * 4. The remainder defines what should be the 14th digit of the receptionNo
 * 5. Case the remainder matches, return true: valid, otherwise return false: invalid
 * @param receptionNo
 * @returns true: valid | false: invalid
 */
export const isValidReceptionNo = (receptionNo: string) => {
  const first3Digits = receptionNo.slice(0, 3);
  let transformedPrefix: string;

  const isIwin = IwinFirst3.includes(first3Digits);
  if (isIwin) {
    transformedPrefix = first3Digits.replace(/[a-zA-Z]/g, '0'); // this will always be 000
  } else {
    transformedPrefix = first3Digits.replace(/[a-zA-Z]/g, '').padStart(3, '0');
  }
  const transformedReceptionNo = transformedPrefix + receptionNo.slice(3);
  const multipliedDigits = coefficients.map((factor, index) => Number(transformedReceptionNo.charAt(index)) * factor);
  const subTotal = multipliedDigits.reduce((sum, num) => sum + (Number(num) || 0), 0);
  const remainder = subTotal % 11;

  let checkDigit = 11 - remainder;
  if (remainder === 1) {
    checkDigit = 0;
  }
  if ([0, 10].includes(remainder)) {
    checkDigit = 1;
  }

  return Number(receptionNo.slice(-1)) === checkDigit;
};
